module.exports = __webpack_public_path__ + "static/img/9areaA_02.950b055.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/9areaA_02.png
// module id = 819
// module chunks = 1